import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { DragAndDropDirective } from "./directives/drag-and-drop.directive";
import { ApastropheThousandPipe } from "./pipes/apastrophe-thousand.pipe";
import { TimePickerComponent } from "./components/time-picker/time-picker.component";

@NgModule({
  declarations: [
    DragAndDropDirective,
    ApastropheThousandPipe,
    TimePickerComponent,
  ],
  imports: [CommonModule, TranslateModule],
  exports: [DragAndDropDirective, ApastropheThousandPipe, TimePickerComponent],
})
export class SharedModule {}
